
import { Student } from "../../types/models";
import { supabase } from "../../lib/supabase";
import { mapStudentFromSupabase } from "../mappers/entityMappers";

export const getStudentsByFamily = async (familyId: string): Promise<Student[]> => {
  const { data, error } = await supabase
    .from("students")
    .select("*")
    .eq("family_id", familyId);
  if (error) throw error;
  return (data || []).map(mapStudentFromSupabase);
};

export const addStudent = async (
  student: Omit<Student, "id" | "created_at">
): Promise<Student> => {
  const { data, error } = await supabase
    .from("students")
    .insert([student])
    .select()
    .single();
  if (error || !data) throw error;
  return mapStudentFromSupabase(data);
};
